import React, { Fragment, MouseEvent } from 'react';
import cn from 'classnames';

import classes from './tile-switch-list.module.scss';

interface TileSwitchListProps {
  activeIndex: number;
  childrenCount: number;
  id?: string;

  onSwitchChange: (index: number) => void;
}

const TileSwitchList = ({ childrenCount, activeIndex, onSwitchChange, id }: TileSwitchListProps) => {
  const handleSwitchClick = (event: MouseEvent) => {
    const elem = event.target as HTMLButtonElement;
    const dataIndex = elem.getAttribute('data-index');

    if (dataIndex) {
      onSwitchChange(Number(dataIndex));
    }
  };

  return (
    <ul className={classes.switch_list} onClick={handleSwitchClick}>
      {Array.from({ length: childrenCount }, (_, idx) => (
        <Fragment key={idx}>
          <li
            id={id ? `${id}SwitchCircle${idx}` : undefined}
            className={cn(classes.switch_circle, {
              [classes.switch_circle_active]: activeIndex === idx
            })}
            data-index={idx}
          />
        </Fragment>
      ))}
    </ul>
  );
};

export default TileSwitchList;
